import React, { useState } from "react";
import { ReactComponent as StarIcon } from "static/icons/star-icon.svg";
import "./Ratting.scss";
import classNames from "classnames";

const Rating = ({
    initialRatting = 0,
    rattingGrade = [0, 20, 40, 60, 80],
    isEditable = true,
    callback,
}) => {
  const [rating, setRating] = useState(initialRatting);

  const handleRattingClick = (value) => {
    if (!isEditable) {
      return
    }
    setRating(value);
    callback?.(value)
  };

  return (
    <div className="rating">
      {rattingGrade?.length > 0 && rattingGrade.map((value, index) => {
        const isChecked = value <= rating;
        return (
          <div key={`${index}-${value}`} onClick={() => handleRattingClick(value)}>
              <StarIcon className={ classNames({
                  "star": true,
                  "editable": isEditable,
                  "checked" : isChecked,
                  "default" : !isChecked,
                })}
                />
          </div>
        );
      })}
    </div>
  );
};

export default Rating;